import { CommonEntrypoint } from "entrypoint/CommonEntrypoint"; 
import 'presentation/style/index.scss'; 
import GroupMaintenanceCont from "presentation/view/container/Group/GroupContMain"; 
CommonEntrypoint(<GroupMaintenanceCont/>) 
